import store from '@/store'
import { MessageBox } from 'element-ui'
import moment from 'moment'

let watermarkDiv = null
const watermarkId = 'watermark-div'
let isUpdating = false

// 根据当前主题获取水印颜色（浓度提升：亮色 0.08，暗色 0.12，确保能被看清但不过分干扰）
const getWatermarkColor = () => {
  const isDark = document.documentElement.classList.contains('dark')
  return isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.08)'
}

// 解密 JwtToken
const decodeJwt = (token) => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const rawData = atob(base64)
    // 使用双字节转换来支持 utf-8 的中文姓名解码，防止乱码
    const jsonPayload = decodeURIComponent(rawData.split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  } catch (e) {
    try {
      // 备用 escape 解密方案
      const base64Url = token.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      return JSON.parse(decodeURIComponent(escape(atob(base64))))
    } catch (err) {
      console.error('JwtToken 解析失败:', err)
      return null
    }
  }
}

// 获取当前登录用户的真实姓名，优先从 JwtToken 中解码获取
const getUserRealName = () => {
  const token = store.getters.token
  if (token) {
    const payload = decodeJwt(token)
    if (payload) {
      const name = payload.real_name || payload.realName || payload.name || payload.nickname || payload.user_name || payload.userName || payload.cn_name
      if (name) return name
    }
  }
  const user = store.getters.user || {}
  return user.realName || user.name || user.nickname || store.getters.name || '系统用户'
}

export const addWatermark = (text, color) => {
  isUpdating = true
  removeWatermark()

  const watermarkColor = color || getWatermarkColor()
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const fontSize = 16
  canvas.width = 300
  canvas.height = 150

  if (ctx) {
    ctx.font = `${fontSize}px Arial`
    ctx.fillStyle = watermarkColor
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(-Math.PI / 6)
    ctx.fillText(text, 0, 0)
  }

  const base64Url = canvas.toDataURL('image/png')
  watermarkDiv = document.createElement('div')
  watermarkDiv.id = watermarkId
  watermarkDiv.style.position = 'fixed'
  watermarkDiv.style.pointerEvents = 'none'
  watermarkDiv.style.top = '0'
  watermarkDiv.style.left = '0'
  watermarkDiv.style.width = '100vw'
  watermarkDiv.style.height = '100vh'
  watermarkDiv.style.backgroundImage = `url(${base64Url})`
  watermarkDiv.style.backgroundRepeat = 'repeat'
  watermarkDiv.style.zIndex = '99999'
  watermarkDiv.style.userSelect = 'none'
  watermarkDiv.style.display = 'block'

  try {
    document.body.appendChild(watermarkDiv)
    console.log('水印元素已添加到DOM')
  } catch (e) {
    console.error('添加水印失败:', e)
  }

  setTimeout(() => {
    isUpdating = false
  }, 100)
}

export const removeWatermark = () => {
  isUpdating = true
  if (watermarkDiv) {
    try {
      if (watermarkDiv.parentNode) {
        watermarkDiv.parentNode.removeChild(watermarkDiv)
      }
      watermarkDiv = null
    } catch (e) {
      console.error('移除水印失败:', e)
    }
  }
  setTimeout(() => {
    isUpdating = false
  }, 100)
}

export const initWatermark = () => {
  const token = store.getters.token
  if (!token) {
    return
  }
  const globalWatermarkEnabled = true
  const userName = getUserRealName()
  console.log('水印初始化 - 用户名:', userName)
  if (globalWatermarkEnabled) {
    const time = moment().format('YYYY-MM-DD')
    const watermarkText = `${userName} ${time}`
    addWatermark(watermarkText, getWatermarkColor())
  }

  const observer = new MutationObserver((mutations) => {
    if (!store.getters.token) {
      return
    }

    const wmInstance = document.getElementById(watermarkId)
    const globalWatermarkEnabled = true
    let watermarkRemoved = false
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && !isUpdating) {
        for (let i = 0; i < mutation.removedNodes.length; i++) {
          const node = mutation.removedNodes[i]
          if (node instanceof HTMLElement && node.id === watermarkId) {
            watermarkRemoved = true
            break
          }
        }
        if (watermarkRemoved) break
      }
    }

    if (watermarkRemoved) {
      const time = moment().format('YYYY-MM-DD')
      const name = getUserRealName()
      const watermarkText = `${name} ${time}`
      addWatermark(watermarkText, getWatermarkColor())
      MessageBox.alert('禁止删除水印，已记录此行为！', '系统提示', {
        confirmButtonText: '我知道了',
        confirmButtonClass: 'el-button--small',
        type: 'warning',
        autofocus: false
      })
      return
    }
    if (!wmInstance && globalWatermarkEnabled) {
      const time = moment().format('YYYY-MM-DD')
      const name = getUserRealName()
      const watermarkText = `${name} ${time}`
      addWatermark(watermarkText, getWatermarkColor())
    } else if (wmInstance && !globalWatermarkEnabled) {
      removeWatermark()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'id']
  })

  store.watch(
    (state) => state.user.token,
    (newValue) => {
      if (newValue && store.state.settings.Watermark) {
        const time = moment().format('YYYY-MM-DD')
        const name = getUserRealName()
        const watermarkText = `${name} ${time}`
        addWatermark(watermarkText, getWatermarkColor())
      } else {
        removeWatermark()
      }
    }
  )
}

export const forceAddWatermark = () => {
  try {
    if (!store.getters.token) {
      return
    }

    const userName = getUserRealName()
    const time = moment().format('YYYY-MM-DD')
    const watermarkText = `${userName} ${time}`
    const color = getWatermarkColor()

    addWatermark(watermarkText, color)
  } catch (e) {
    console.error('添加水印失败:', e)
  }
}

export const watermarkDirective = {
  bind (el) {
    setTimeout(() => {
      if (store.getters.token) {
        forceAddWatermark()
      }
    }, 200)
  }
}
